import React from 'react';
import 'whatwg-fetch';

import ModalDealPost from '../modal/modalDealPost';
import ModalTaskPost from '../modal/modalTaskPost';
import ModalAppointmentPost from '../modal/modalAppointmentPost';
import ModalReminderPost from '../modal/modalReminderPost';
import ModalNotePost from '../modal/modalNotePost';
import ModalContactPost from '../modal/modalContactPost';
import ModalCustomerLink from '../modal/modalCustomerLink';
import ModalConfirm from '../modal/modalConfirm';
import ModalExistingContact from '../modal/modalExistingContact';
import { appendGraphQlPlanning } from 'src/utils/utilPlanning';
import { showEntity } from 'src/utils/entityApi';
import MyPlanning from '../../appPlanning/myPlanning';
import SubNavBar from '../SubNavBar';
import CustomerMigrationView from './components/CustomerMigrationView';
import { Grid } from '@material-ui/core';
import { RiForbidLine as ForbidIcon } from '@react-icons/all-files/ri/RiForbidLine';
import CustomerNavigation from './components/CustomerNavigation';
import CustomerInformationsCard from './components/CustomerInformationsCard';
import MenuButton from 'src/scenes/components/display/components/MenuButton';
import { SiteContextProvider } from 'src/scenes/components/display/hooks/useSite';
import withAuth from 'src/hoc/withAuth';

const apiTask = '/api/task/';
const apiAppointment = '/api/appointment/';
const apiReminder = '/api/reminder/';
const apiNote = '/api/note/';
const apiCustomerShow = '/api/customer/show/';
const apiProFields = '/api/customer/profield/';
const apiEmployeeShow = '/api/employee/';

class DisplayCustomer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fatalError: undefined,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalPostDealOpen: false,
      isModalPostContactOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      isModalLinkCustomerOpen: false,
      isModalDeleteSubOfficeOpen: false,
      isModalTerminateOpen: false,
      isModalLiquidationOpen: false,
      isModalImpayeeOpen: false,
      isModalCustomerChangeOpen: false,
      isModalExistingContactOpen: false,
      toAssociate: {
        type: 'customer',
      },
      textModal: {
        title: 'default title',
        message: 'default message',
      },
      customerId: undefined,
      customerName: '____',
      customerTermination: false,
      customerLiquidation: false,
      customerImpayee: false,
      customerProField: undefined,
      customerSiret: '____',
      customerDeals: undefined,
      customerTickets: undefined,
      customerContacts: undefined,
      customerExternalContacts: undefined,
      extendedDeals: false,
      extendedTickets: false,
      extendedContacts: false,
      extendedSubOffices: false,
      extendedExternalContacts: false,
      customerHeadOffice: undefined,
      customerSubOffices: undefined,
      subOfficeToRemoveId: undefined,
      dataProFields: undefined,
      customerChangeGraphKey: undefined,
      customerChangeNewState: undefined,
      triggerContact: undefined,
      dataEmployees: undefined,
      loading: false,
      customerFetched: false,
      hourContract: false,
      telecomMaintenanceContract: false,
      computerMaintenanceContract: false,
      recoveryTimeGuarantee: false,
      interventionTimeGuarantee: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postResult = this.postResult.bind(this);
    this.linkResult = this.linkResult.bind(this);
    this.deleteSubOffice = this.deleteSubOffice.bind(this);
    this.updateCustomerRequest = this.updateCustomerRequest.bind(this);
    this.terminate = this.terminate.bind(this);
    this.liquidation = this.liquidation.bind(this);
    this.impayee = this.impayee.bind(this);
    this.mutationResult = this.mutationResult.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.refreshData(this.props.match.params.id);
  }

  refreshData = (customerId) => {
    if (customerId) {
      this.setState({ loading: true, fatalError: undefined });

      let queryURL = apiCustomerShow;
      let graphQL =
        '{ customer(id:' +
        customerId +
        '){ id, telecomMaintenanceContract, hourContract, computerMaintenanceContract, recoveryTimeGuarantee, interventionTimeGuarantee, termination, impayee, liquidation, triggerContact{id, name, lastname, deleted}, ' +
        'headOffice{id, installationSite{ socialReason }}, ' +
        'subOffices{id, dateCreate, installationSite{ socialReason }, ' +
        'creator{ user{ id, username } }} ,creator{ user{ id, username } }, ' +
        'assignedEmployeeTelecom{ id }, ' +
        'assignedEmployeeInformatique{ id }, ' +
        'tickets{ id, deleted, subject, dateCreate, closingDate, closedReason{id, label}, domain{ id }, state, closed, supportEmployee{ user{ id, username } } }, ' +
        'contacts{ id, name, lastname, origin{ labelOrigin }, companyName, job, phoneNumber, email, deleted}, professionalField{ id, wording }, ' +
        'externalContacts{ id, name, lastname, job, deleted}, professionalField{ id, wording }, ' +
        'installationSite{ socialReason, adress, postalCode, telOffice, telFax, siret }, ' +
        'deals{ id, customerSatisfactionCommercialRating, customerSatisfactionInstallationRating, customerSatisfactionPreparationRating, name, deleted, type{ name }, lost, dateCreate, contractEndDate, domain{ id }, creator{ user{ id, username } }, ' +
        'stepCommercial{ intermediateStageNumber }, stepProd{ preparation{ ' +
        'associationsProductsHardware{ id, products{ id, installed, stickerId }, ' +
        'quoteArticle{ id, quantity, productReference{ id, wording } } },' +
        'associationsProductsVirtual{ id, products{ id, installed }, quoteArticle{ id, quantity, productReference{ id, wording } } },' +
        ' } } }' +
        appendGraphQlPlanning() +
        ' } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['customer']) {
            let toAssociate = this.state.toAssociate;
            toAssociate['id'] = data['data']['customer']['id'];
            toAssociate['name'] = data['data']['customer']['installationSite']['socialReason'];
            this.setState({
              toAssociate: toAssociate,
              customerId: data['data']['customer']['id'],
              customerCreator: data['data']['customer']['creator'],
              assignedEmployeeTelecom: data['data']['customer']['assignedEmployeeTelecom'],
              assignedEmployeeInformatique: data['data']['customer']['assignedEmployeeInformatique'],
              adress: data['data']['customer']['installationSite']['adress'],
              postalCode: data['data']['customer']['installationSite']['postalCode'],
              telOffice: data['data']['customer']['installationSite']['telOffice'],
              telFax: data['data']['customer']['installationSite']['telFax'],
              customerName: data['data']['customer']['installationSite']['socialReason'],
              customerTermination: data['data']['customer']['termination'],
              customerImpayee: data['data']['customer']['impayee'],
              customerLiquidation: data['data']['customer']['liquidation'],
              customerProField: data['data']['customer']['professionalField'],
              customerSiret: data['data']['customer']['installationSite']['siret'],
              customerDeals: data['data']['customer']['deals'],
              customerTickets: data['data']['customer']['tickets'],
              customerContacts: data['data']['customer']['contacts'],
              dataTask: data['data']['customer']['tasks'],
              dataAppointment: data['data']['customer']['appointments'],
              dataReminder: data['data']['customer']['reminders'],
              dataNote: data['data']['customer']['notes'],
              customerHeadOffice: data['data']['customer']['headOffice'],
              customerSubOffices: data['data']['customer']['subOffices'],
              triggerContact: data['data']['customer']['triggerContact'],
              telecomMaintenanceContract: data['data']['customer']['telecomMaintenanceContract'],
              computerMaintenanceContract: data['data']['customer']['computerMaintenanceContract'],
              hourContract: data['data']['customer']['hourContract'],
              recoveryTimeGuarantee: data['data']['customer']['recoveryTimeGuarantee'],
              interventionTimeGuarantee: data['data']['customer']['interventionTimeGuarantee'],
              customerExternalContacts: data['data']['customer']['externalContacts'],
              customerFetched: true,
            });
          } else {
            let message = 'Erreur lors de la récupération du client';

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({ fatalError: error.message });
        })
        .finally(() => this.setState({ loading: false }));

      this.getProfessionalFields();
      this.getEmployees();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.refreshData(this.props.match.params.id);
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  getProfessionalFields = () => {
    let queryURL = apiProFields;
    let graphQL = '{ professionalFields{ id, wording } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          dataProFields: data['data']['professionalFields'],
        });
      })
      .catch((error) => {
        console.log('erreur fetch pro fields: \n' + error);
      });
  };

  getEmployees = () => {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname, user{id, username} } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['employees']) {
          this.setState({
            dataEmployees: data['data']['employees'],
          });
        }
      })
      .catch((error) => {
        console.log('erreur fetch list employees entity: \n' + error);
      });
  };

  handleCustomerChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'professionalField') {
      this.openModalCustomerChange('professionalFieldId', value);
    } else if (name === 'assignedEmployeeTelecom') {
      this.openModalCustomerChange('assignedEmployeeTelecomId', value);
    } else if (name === 'assignedEmployeeInformatique') {
      this.openModalCustomerChange('assignedEmployeeInformatiqueId', value);
    }
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalPostDealOpen: false,
      isModalPostContactOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      isModalLinkCustomerOpen: false,
      isModalDeleteSubOfficeOpen: false,
      isModalTerminateOpen: false,
      isModalImpayeeOpen: false,
      isModalLiquidationOpen: false,
      isModalCustomerChangeOpen: false,
      isModalExistingContactOpen: false,
    });
  }

  openModalCustomerChange = (graphKey, newState) => {
    let modal = {
      title: 'Compte',
      message: 'Vous allez modifier le compte ',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalCustomerChangeOpen: true,
      customerChangeGraphKey: graphKey,
      customerChangeNewState: newState,
    });
  };

  updateCustomerRequest() {
    if (this.state.customerId && this.state.customerChangeGraphKey && this.state.customerChangeNewState) {
      let graphQL =
        'mutation{ customer(id:' +
        this.state.customerId +
        ',' +
        this.state.customerChangeGraphKey +
        ':' +
        this.state.customerChangeNewState +
        ' ){ id } }';
      this.mutationResult(showEntity(this.props.authFetch, 'customer', graphQL));
    }
  }

  deleteCollaborative = (id, type) => {
    let json = { [type]: { id } };

    let collaborative = {
      type: undefined,
      message: undefined,
      apiUrl: undefined,
    };

    let afterView = 1;
    switch (type) {
      case 'task':
        collaborative.type = 'task';
        collaborative.message = 'tâche';
        collaborative.apiUrl = apiTask;
        afterView = 1;
        break;
      case 'appointment':
        collaborative.type = 'appointment';
        collaborative.message = 'rendez-vous';
        collaborative.apiUrl = apiAppointment;
        afterView = 2;
        break;
      case 'reminder':
        collaborative.type = 'reminder';
        collaborative.message = 'rappel';
        collaborative.apiUrl = apiReminder;
        afterView = 3;
        break;
      case 'note':
        collaborative.type = 'note';
        collaborative.message = 'note';
        collaborative.apiUrl = apiNote;
        afterView = 4;
        break;
    }

    let queryURL = collaborative.apiUrl;
    let tabParam = encodeURIComponent(JSON.stringify(json));
    queryURL += tabParam;

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.isValid) {
          this.refreshData(this.props.match.params.id);
          this.setState({ selectedView: afterView });
          this.props.openToast(true, 'Suppression réalisée ');
        } else {
          this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.openToast(false, 'Impossible à supprimer');
      });
  };

  openModal(type, entity = null) {
    let toOpen = undefined;
    switch (type) {
      case 'deal':
        toOpen = 'isModalPostDealOpen';
        break;
      case 'contact':
        toOpen = 'isModalPostContactOpen';
        break;
      case 'task':
        toOpen = 'isModalPostTaskOpen';
        break;
      case 'appointment':
        toOpen = 'isModalPostAppointmentOpen';
        break;
      case 'reminder':
        toOpen = 'isModalPostReminderOpen';
        break;
      case 'note':
        toOpen = 'isModalPostNoteOpen';
        break;
      case 'link':
        toOpen = 'isModalLinkCustomerOpen';
        break;
      case 'existingContact':
        toOpen = 'isModalExistingContactOpen';
        break;
      case 'delete-subOffice':
        toOpen = 'isModalDeleteSubOfficeOpen';
        let modalText = {
          title: 'Retirer sous-compte ',
          message: 'Vous allez retirer le lien avec ' + entity.installationSite.socialReason,
        };
        this.setState({
          textModal: modalText,
          subOfficeToRemoveId: entity.id,
        });
        break;
      case 'terminate':
        toOpen = 'isModalTerminateOpen';
        this.setState({
          textModal: {
            title: 'Modification',
            message: 'Vous allez modifier le statut de résiliation du client',
          },
        });
        break;
      case 'liquidation':
        toOpen = 'isModalLiquidationOpen';
        this.setState({
          textModal: {
            title: 'Modification',
            message: 'Vous allez modifier le statut de liquidation du client',
          },
        });
        break;
      case 'impayee':
        toOpen = 'isModalImpayeeOpen';
        this.setState({
          textModal: {
            title: 'Modification',
            message: 'Vous allez modifier le statut impayé du client',
          },
        });
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    switch (type) {
      case 'ticket':
        messageLabel = 'ticket';
        break;
      case 'deal':
        messageLabel = 'affaire';
        break;
      case 'contact':
        messageLabel = 'contact';
        break;
      case 'task':
        messageLabel = 'tâche';
        break;
      case 'appointment':
        messageLabel = 'rdv';
        break;
      case 'reminder':
        messageLabel = 'rappel';
        break;
      case 'note':
        messageLabel = 'note';
        break;
    }
    promise.then((result) => {
      if (result.wentFine) {
        this.props.openToast(true, 'Succès création ' + messageLabel);
        this.refreshData(this.props.match.params.id);
      } else {
        this.props.openToast(false, 'Erreur création ' + messageLabel + '. Veuillez réessayer');
      }
    });
  }

  linkResult() {
    this.refreshData(this.props.match.params.id);
  }

  /*
        This method is used to terminate (contract) a customer account
     */
  terminate() {
    let graphQL =
      'mutation { customer(id:' +
      this.state.customerId +
      ', termination:' +
      !this.state.customerTermination +
      '){id, termination}}';
    this.mutationResult(showEntity(this.props.authFetch, 'customer', graphQL));
  }

  liquidation() {
    let graphQL =
      'mutation { customer(id:' +
      this.state.customerId +
      ', liquidation:' +
      !this.state.customerLiquidation +
      '){id, liquidation}}';
    this.mutationResult(showEntity(this.props.authFetch, 'customer', graphQL));
  }

  impayee() {
    let graphQL =
      'mutation { customer(id:' +
      this.state.customerId +
      ', impayee:' +
      !this.state.customerImpayee +
      '){id, impayee}}';
    this.mutationResult(showEntity(this.props.authFetch, 'customer', graphQL));
  }

  mutationResult(promise) {
    let messageLabel = ': statut du compte';

    promise.then((result) => {
      if (result.wentFine) {
        this.props.openToast(true, 'Succès modification ' + messageLabel);
        this.refreshData(this.props.match.params.id);
      } else {
        this.props.openToast(false, 'Erreur modification ' + messageLabel + '. Veuillez réessayer');
      }
    });
  }

  /*
        This method is used to remove a linked sub-office
    */
  deleteSubOffice() {
    let graphQL =
      'mutation { customer(id:' +
      this.state.customerId +
      ', removeSubOfficeId:' +
      this.state.subOfficeToRemoveId +
      '){id, subOffices{ id }}}';

    let queryURL = apiCustomerShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['customer']['subOffices'].length != this.state.customerSubOffices.length) {
          this.props.openToast(true, 'Le lien a bien été retiré.');
          this.refreshData(this.props.match.params.id);
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      })
      .catch(() => {
        console.log('erreur fetch UPDATE customer entity');
      });
  }

  render() {
    let triggerCustomer = {
      id: this.state.customerId,
      name: this.state.customerName,
      triggerContact: this.state.triggerContact,
      customerContacts: this.state.customerContacts,
      customerExternalContacts: this.state.customerExternalContacts,
    };

    const canMigrateCustomer =
      !this.state.customerImpayee && !this.state.customerTermination && !this.state.customerLiquidation;

    return (
      <SiteContextProvider legacyCustomerId={this.props.match.params.id}>
        <div id='appView' className='div-entity'>
          <SubNavBar
            toggleAppViewNavExtended={this.toggleAppViewNavExtended}
            goBack={this.props.history.goBack}
            appViewNavExtended={this.state.appViewNavExtended}
            title='Compte client'
          >
            <div className={'appViewNavMenu-alignRight'}>
              <MenuButton label='Affaire' icon='icon-plus' onClick={() => this.openModal('deal')} />
              <MenuButton label='Contact' icon='icon-plus' onClick={() => this.openModal('contact')} />
              <MenuButton label='Contact externe' icon='icon-link' onClick={() => this.openModal('existingContact')} />
              <MenuButton label='Tâche' icon='icon-plus' onClick={() => this.openModal('task')} />
              <MenuButton label='Rdv' icon='icon-plus' onClick={() => this.openModal('appointment')} />
              <MenuButton label='Rappel' icon='icon-plus' onClick={() => this.openModal('reminder')} />
              <MenuButton label='Note' icon='icon-plus' onClick={() => this.openModal('note')} />
              <MenuButton label='Lier' icon='icon-link' onClick={() => this.openModal('link')} />
              <MenuButton
                label={this.state.customerTermination ? 'Contractualiser à nouveau' : 'Résilier'}
                icon='icon-link'
                onClick={() => this.openModal('terminate')}
              />

              {!this.state.customerLiquidation && (
                <MenuButton
                  label='Liquidation'
                  icon='icon-creative-commons-noncommercial-eu'
                  onClick={() => this.openModal('liquidation')}
                />
              )}

              <MenuButton
                label={`${this.state.customerImpayee ? 'Enlever' : 'Ajouter'} le statut impayé`}
                icon='icon-creative-commons-noncommercial-eu'
                onClick={() => this.openModal('impayee')}
              />
            </div>
          </SubNavBar>

          {!this.state.fatalError ? (
            <div>
              <form>
                {canMigrateCustomer && !this.state.loading && this.state.customerFetched && (
                  <CustomerMigrationView
                    customerId={this.state.customerId || ''}
                    customerName={this.state.customerName || ''}
                    address={this.state.adress || ''}
                    city={this.state.postalCode || ''}
                    siret={this.state.customerSiret || ''}
                    phoneNumber={this.state.telOffice || ''}
                    fax={this.state.telFax || ''}
                  />
                )}

                {this.state.customerTermination && (
                  <div className='alert alert-danger' role='alert'>
                    Ce client est résilié
                  </div>
                )}
                {this.state.customerImpayee && (
                  <div className='alert-big-danger' role='alert'>
                    <ForbidIcon size={40} /> Ce client a le statut impayé <ForbidIcon size={40} />
                  </div>
                )}
                {this.state.customerLiquidation && (
                  <div className='alert alert-danger' role='alert'>
                    Ce client est en liquidation judiciaire
                  </div>
                )}

                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <CustomerInformationsCard
                      openToast={this.props.openToast}
                      customerId={this.state.customerId}
                      refreshData={this.refreshData}
                      customerName={this.state.customerName}
                      dataEmployees={this.state.dataEmployees}
                      dataProFields={this.state.dataProFields}
                      customerCreator={this.state.customerCreator}
                      customerProFieldId={(this.state.customerProField || {}).id}
                      customerHeadOffice={this.state.customerHeadOffice}
                      recoveryTimeGuarantee={this.state.recoveryTimeGuarantee}
                      assignedEmployeeTelecomId={(this.state.assignedEmployeeTelecom || {}).id}
                      assignedEmployeeInformatiqueId={(this.state.assignedEmployeeInformatique || {}).id}
                      openModalCustomerChange={this.openModalCustomerChange}
                      interventionTimeGuarantee={this.state.interventionTimeGuarantee}
                      computerMaintenanceContract={this.state.computerMaintenanceContract}
                      telecomMaintenanceContract={this.state.telecomMaintenanceContract}
                      hourContract={this.state.hourContract}
                      triggerContact={this.state.triggerContact}
                    />
                  </Grid>

                  <Grid item xs={12} md={9}>
                    <CustomerNavigation
                      customerContacts={this.state.customerContacts}
                      customerDeals={this.state.customerDeals}
                      customerId={this.state.customerId}
                      customerExternalContacts={this.state.customerExternalContacts}
                      customerSubOffices={this.state.customerSubOffices}
                      customerTickets={this.state.customerTickets}
                      loading={this.state.loading}
                      openModal={this.openModal}
                    />
                  </Grid>
                </Grid>
              </form>

              <MyPlanning
                onEntity={true}
                dataTask={this.state.dataTask}
                dataAppointment={this.state.dataAppointment}
                dataReminder={this.state.dataReminder}
                dataNote={this.state.dataNote}
                deleteCollaborative={this.deleteCollaborative}
              />
            </div>
          ) : (
            <div className='alert alert-danger' role='alert'>
              {this.state.fatalError}
            </div>
          )}

          <ModalDealPost
            className='myModal'
            myCustomer={triggerCustomer}
            openToast={this.props.openToast}
            isOpen={this.state.isModalPostDealOpen}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalContactPost
            className='myModal'
            myCustomer={triggerCustomer}
            openToast={this.props.openToast}
            isOpen={this.state.isModalPostContactOpen}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalTaskPost
            entityAssociated={this.state.toAssociate}
            className='myModal'
            isOpen={this.state.isModalPostTaskOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalAppointmentPost
            entityAssociated={this.state.toAssociate}
            className='myModal'
            isOpen={this.state.isModalPostAppointmentOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalReminderPost
            entityAssociated={this.state.toAssociate}
            className='myModal'
            isOpen={this.state.isModalPostReminderOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalNotePost
            entityAssociated={this.state.toAssociate}
            className='myModal'
            isOpen={this.state.isModalPostNoteOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalCustomerLink
            entityAssociated={this.state.toAssociate}
            onLinkResult={this.linkResult}
            className='myModal'
            isOpen={this.state.isModalLinkCustomerOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalExistingContact
            entityAssociated={this.state.toAssociate}
            onLinkResult={this.linkResult}
            className='myModal'
            isOpen={this.state.isModalExistingContactOpen}
            openToast={this.props.openToast}
            onPostResult={this.postResult}
            onClose={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalDeleteSubOfficeOpen}
            onSubmit={this.deleteSubOffice}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalTerminateOpen}
            onSubmit={this.terminate}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalLiquidationOpen}
            onSubmit={this.liquidation}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalImpayeeOpen}
            onSubmit={this.impayee}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalCustomerChangeOpen}
            onSubmit={this.updateCustomerRequest}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          />
        </div>
      </SiteContextProvider>
    );
  }
}

export default withAuth(DisplayCustomer);
